import { createAsyncThunk } from '@reduxjs/toolkit';
import { deletePipingProjectDetailPipingList } from '../../api/piping-project-detail-piping-lists';

export const deletePipingProjectDetailPipingListAsync = createAsyncThunk(
  'pipingProjectDetailPipingLists/deletePipingProjectDetailPipingList',
  deletePipingProjectDetailPipingList
);
